type PageObject = {
  name: string
  description: string
}

type ImpactModulePages = {
  [key: string]: PageObject
}

export const CITIZEN_PROFILE_PAGES: ImpactModulePages = {
  DASHBOARD: {
    name: 'Relatórios',
    description: 'Gestão dos relatórios',
  },
  UNIFIED_PERSON: {
    name: 'Cidadãos',
    description: 'Gestão dos cidadãos',
  },
  IDENTITY_CARD: {
    name: 'Cartões de identidade',
    description: 'Gestão dos cartões de identidade',
  },
  FAMILY: {
    name: 'Famílias',
    description: 'Gestão das famílias',
  },
  GROUP_MODULE_PERMISSION: {
    name: 'Permissões de grupos',
    description: 'Gestão das permissões dos grupo',
  },
  PUBLIC_AGENT_MODULE_PERMISSION: {
    name: 'Permissões dos agentes',
    description: 'Gestão das permissões dos agentes públicos',
  },
}
